import script from "./ArticleCategoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleCategoryPage.vue?vue&type=script&setup=true&lang=js"

import "./ArticleCategoryPage.vue?vue&type=style&index=0&id=1e60f984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e60f984"]])

export default __exports__